import { Locale } from 'modules/i18n';

export const promoBadgeTranslation = {
  [Locale.en]: {
    label: 'Promo',
  },
};
